import { Button } from "components/DesignSystem/Button/Button";
import ChatCard from "components/DesignSystem/ChatCard/ChatCard";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { Files } from "components/icons/Files";
import { ReviewDocHeader } from "components/icons/ReviewDocHeader";
import { ReviewDftFields } from "components/MessageBubble/FilingDraft/ReviewDftFields";
import { useAppSelector } from "hooks/useAppSelector";
import { useModal } from "hooks/useModal";
import { formatNumber } from "utils/formatNumber";

export const DftDraftForReview = () => {
  const dftFilingDraftReview = useAppSelector(
    (state) => state.dftFilingDraftReview
  );
  const draftReview = useModal();

  return (
    <>
      <ChatCard.Root size="block">
        <ChatCard.Header>
          <div className="t-gap-1.5 t-flex t-items-center">
            <ReviewDocHeader />
            Review Filing Draft
          </div>
        </ChatCard.Header>
        <ChatCard.Body>
          <div className="t-flex t-gap-2.5 t-items-center t-justify-between">
            <div className="t-flex t-gap-2.5 t-items-center">
              <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
                <div className="t-text-text-30 -t-mt-0.5">
                  <Files />
                </div>
              </div>
              {dftFilingDraftReview?.taxAmount && (
                <div>
                  <div className="t-text-body-sm t-text-text-30 t-font-light">
                    Tax payable
                  </div>
                  <div className="t-text-subtext-sm t-text-text-60">
                    ${formatNumber(dftFilingDraftReview?.taxAmount)}
                  </div>
                </div>
              )}
            </div>
            <Tag tagType="orange" icon={false} rounded size="small">
              Pending review
            </Tag>
          </div>
          <Button size="small" customType="primary" onClick={draftReview.open}>
            Review
          </Button>
        </ChatCard.Body>
      </ChatCard.Root>
      {dftFilingDraftReview && (
        <ReviewDftFields
          {...draftReview}
          isLoading={false}
          isSuccess
          taxAmountPayable={dftFilingDraftReview.taxAmount}
          grossAssetValue={dftFilingDraftReview.grossAssetValue}
          fileId={dftFilingDraftReview.file.uuid}
          groupId={dftFilingDraftReview.groupId}
        />
      )}
    </>
  );
};
